import React from 'react';
import cx from 'clsx';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

interface TableSortIconProps extends SvgIconProps {
  direction?: 'ASC' | 'DESC';
}

const useStyles = makeStyles(() => {
  return {
    root: {
      width: '20px',
      height: '20px'
    }
  };
});

const TableSortIcon: React.FC<TableSortIconProps> = ({ direction, className, ...rest }) => {
  const { root } = useStyles();

  if (!direction) return <></>;

  return (
    <Box displayPrint="none">
      {direction === 'ASC' ? (
        <ArrowDropDownIcon className={cx(root, className)} {...rest} />
      ) : (
        <ArrowDropUpIcon className={cx(root, className)} {...rest} />
      )}
    </Box>
  );
};

export default TableSortIcon;
